import React, { useEffect, useState } from 'react';
import { Loader2, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PC = /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/;

const useAddresses = (postcode) => {
  const [st, setSt] = useState({ status: 'idle', list: [], msg: '' });
  const pc = (postcode || '').replace(/\s/g, '').toUpperCase();
  useEffect(() => {
    if (!PC.test(pc)) { setSt({ status: 'idle', list: [], msg: '' }); return; }
    let live = true;
    setSt({ status: 'loading', list: [], msg: '' });
    const t = setTimeout(async () => {
      try {
        const r = await fetch(`${API}/address-lookup?postcode=${pc}`);
        const d = await r.json();
        if (!live) return;
        if (r.ok) setSt({ status: 'ready', list: d.addresses, msg: d.addresses.length ? '' : 'No addresses found — please type it below.' });
        else setSt({ status: r.status === 503 && /set up/.test(d.detail || '') ? 'off' : 'error', list: [], msg: d.detail || '' });
      } catch { if (live) setSt({ status: 'error', list: [], msg: '' }); }
    }, 350);
    return () => { live = false; clearTimeout(t); };
  }, [pc]);
  return st;
};

export const AddressFinder = ({ postcode, house, address, onChange, testPrefix, inputCls = '' }) => {
  const st = useAddresses(postcode);
  const cls = inputCls || 'w-full h-11 rounded-md border border-slate-200 bg-white px-3 text-sm';
  const pick = (id) => { const a = st.list.find(x => x.id === id); if (a) onChange({ house: a.house, address: a.address }); };
  return (
    <div className="space-y-2" data-testid={`${testPrefix}-finder`}>
      {st.status === 'loading' && <div className="text-xs text-slate-500 inline-flex items-center gap-1.5"><Loader2 className="w-3.5 h-3.5 animate-spin" /> Finding addresses…</div>}
      {st.status === 'ready' && st.list.length > 0 && (
        <div className="relative">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          <select defaultValue="" onChange={(e) => pick(e.target.value)} className={`${cls} pl-9`} data-testid={`${testPrefix}-select`}>
            <option value="">Choose the address ({st.list.length} found)…</option>
            {st.list.map(a => <option key={a.id} value={a.id}>{a.label}</option>)}
          </select>
        </div>
      )}
      {st.msg && st.status !== 'off' && <div className="text-xs text-amber-700" data-testid={`${testPrefix}-msg`}>{st.msg}</div>}
      <div className="grid grid-cols-[110px_1fr] gap-2">
        <input value={house || ''} onChange={(e) => onChange({ house: e.target.value, address })} placeholder="House no." maxLength={40} className={cls} data-testid={`${testPrefix}-house`} />
        <input value={address || ''} onChange={(e) => onChange({ house, address: e.target.value })} placeholder="Street, town" maxLength={200} className={cls} data-testid={`${testPrefix}-address`} />
      </div>
    </div>
  );
};
